import InputField from "./molecules/input-field";
import Checkbox from "./atoms/check-box";

export default angular.module('app.atomic', [])
    .component('inputField', new InputField)
    .component('aCheckbox', new Checkbox)
    .name;
